import checkRequiredInputs from "./check-required-inputs";

const ValidatePaymentForm = () => {
  const paymentForm = document.querySelector(".payment-block");
  const placeOrder = document.querySelector(".place-order-btn");

  if (paymentForm) {
    const requiredPaymentInputs = [
      ...paymentForm.querySelectorAll('input.wpcf7-validates-as-required'),
      ...document.querySelectorAll('.third-step-btns input[type="checkbox"]'),
      ...paymentForm.querySelectorAll('.radio-btn input[type="radio"]')];

    if (requiredPaymentInputs.length > 0) {
      requiredPaymentInputs.forEach(requiredInput => {
        requiredInput.addEventListener('input', () => checkRequiredInputs(requiredPaymentInputs, placeOrder));
      });
    };
  }
}

export default ValidatePaymentForm;